import React, { useCallback } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import FeatureName from "../../../../../../visComponents/featureName";
import FeatureThumbnail from "../../../../../../visComponents/featureThumbnail";
import { featureInterface } from "../../../../../../../interfaces/featureInterface";
import config from "../../../../canvas/store/sqftConfig";
import { injectIntl } from "react-intl";
import {
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  setSQFTSystemMessage
} from "../../../../../../../actions/sqftMenuFunctions";
import {activateEdgeTool} from "../../../../canvas/core/controls/canvasBridge";
import {getStringFeatureName} from "../../../../../../../misc/helpers";
import {hardCodeIsDeStefano} from "../../../../../../../misc/fabricatorHardcode";
import workspace from "../../../../canvas/core/workspace";
import {RESOURCE_ATTACHED_TO_TYPE} from "../../../../../constants";
import {changeCartFeature} from "../../../../../../../actions/actionFunctions";
import {updateQuoteSqftFeatureIds} from "../../../../../helpers/sqFtCalcDataHelper";
//import store from "../../../../../../../store";

const SqftNavEdgesFeature = (props) => {
  const {edgeFeature, setSQFTSystemMessage, intl, fabricatorData, selectedEdge, setSelectedEdge,
    setSQFTActiveSubMenuButton, newWizardGroupId, isModalFixOpen, modalFixFeatureId, changeCartFeature, cartItems,
    updateQuoteSqftFeatureIds} = props;

  const edgeClick = useCallback((e, disallowDemo) => {
    e.preventDefault();
    if (isModalFixOpen) {
      //update shapeFeatureId on canvas
      const edges = workspace.getAttachedToLineResource(RESOURCE_ATTACHED_TO_TYPE.edge);
      for (const edge of edges) {
        const line = workspace.getLineById(edge.attachedToId);
        if (line) {
          line.setEdgeFeatureId(edgeFeature.dbFeature.id, edgeFeature.getFeatureName());
        }
      }
      //update cartItems
      const incompatibleCartItems = cartItems.filter(cartItem => cartItem.cartFeature.dbFeature.id === modalFixFeatureId);
      incompatibleCartItems.forEach(incompatibleCartItem => {
        changeCartFeature(Object.assign({}, incompatibleCartItem, {
          cartFeature: edgeFeature
        }));
      })
      window.setTimeout(() => {
        updateQuoteSqftFeatureIds(incompatibleCartItems);
      }, 1)
    } else {
      setSelectedEdge(edgeFeature.dbFeature.id);
      setSQFTActiveSubMenuButton(edgeFeature.dbFeature.id);
      activateEdgeTool(edgeFeature, newWizardGroupId, !!disallowDemo);

      if (window.innerWidth < 991 && !config.tutorialIsRunning) {
        //todo sqft-react
        //Menu.hideSideBarContent(); // hide sidebar menu
      }
    }
  }, [ edgeFeature, setSelectedEdge, setSQFTActiveSubMenuButton, newWizardGroupId, updateQuoteSqftFeatureIds,
    cartItems, changeCartFeature, isModalFixOpen, modalFixFeatureId]);

  const handleHelpClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();

    setSQFTSystemMessage({
      isOpened: true,
      title: getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData),
      text: intl.formatMessage({ id: edgeFeature.dbFeature.description })
    });
  }, [edgeFeature, setSQFTSystemMessage, intl, fabricatorData]);

  const isSelected = selectedEdge === edgeFeature.dbFeature.id;
  const featureName = getStringFeatureName(edgeFeature, intl.messages, intl.locale, fabricatorData);

  return (
    <li
      className={
        "lightbox-option-round lightbox-option-round--edge " +
        (isSelected ? "lightbox-option-selected" : "")
      }
      data-id={edgeFeature.dbFeature.id}
      data-shared-feature-name={featureName}
      onClick={edgeClick}
    >
      <div className="lightbox-help-icon lightbox-help-icon-circle" onClick={handleHelpClick} />
      <div className="lightbox-option-round-loader-edge" />
      <div className={" " + (hardCodeIsDeStefano() ? ' lightbox-option-round--mh ' : '')}>
        <FeatureThumbnail feature={edgeFeature} />
      </div>
      <div className={
        "lightbox-description-text lightbox-description-text--edge" +
        (hardCodeIsDeStefano() ? ' lightbox-description-text--mh ' : '')
      }>
        <FeatureName feature={edgeFeature} maxLength={23} />
      </div>
    </li>
  );
};

SqftNavEdgesFeature.propTypes = {
  edgeFeature: PropTypes.shape(featureInterface).isRequired,
  setSQFTSystemMessage: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  selectedEdge: PropTypes.number,
  setSelectedEdge: PropTypes.func.isRequired,
  setSQFTActiveSubMenuButton: PropTypes.func.isRequired,
  newWizardGroupId: PropTypes.string,
  resourceState: PropTypes.object.isRequired
};

const mapStateToProps = (store) => ({
  fabricatorData: store.fabricatorState,
  resourceState: store.sqftResourceState || {},
  isModalFixOpen: store.sqftModalFixState.isModalFixOpen,
  modalFixFeatureId: store.sqftModalFixState.featureId,
  modalFixFeatureName: store.sqftModalFixState.featureName,
  cartItems: store.cartState.cartItems,
});

const mapDispatchToProps = {
  setSQFTSystemMessage,
  setSQFTActiveSubMenuButton,
  setSQFTMenuOpened,
  changeCartFeature,
  updateQuoteSqftFeatureIds,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftNavEdgesFeature)
);
